import Link from "next/link";
import React from "react";
import styles from "./NewsItem.module.scss";
import PushPinIcon from "public/icons/push-pin.svg";
import classnames from "classnames";

interface Props {
  title: string;
  url: string;
  date?: string;
  image?: string;
  badge?: string;
  isPinned?: boolean;
}

const NewsItem = (props: Props) => {
  return (
    <Link href={props.url}>
      <a className={styles.NewsItem}>
        <div className={styles.NewsItem__badgeContainer}>
          {props.isPinned && (
            <span
              className={classnames(
                styles.NewsItem__badge,
                styles.NewsItem__pinned
              )}
            >
              <PushPinIcon />
            </span>
          )}
          {props.badge && (
            <span className={styles.NewsItem__badge}>{props.badge}</span>
          )}
        </div>
        <h5 className={styles.NewsItem__title}>{props.title}</h5>
      </a>
    </Link>
  );
};

export default NewsItem;
